import { useAppSelector } from "@redux/hooks";
import { VersionToast, VersionToastProvider, VersionToastViewport } from "./version-toast";
import { selectVersionMismatch } from "@shared-kernel/application/use-cases/show-version-mismatch/selectors/version-mismatch-selectors";

export function VersionMismatchProvider({ children }: { children: React.ReactNode }) {
  const isOpen = useAppSelector(selectVersionMismatch);

  return (
    <VersionToastProvider>
      {children}
      {isOpen && (
        <VersionToastViewport>
          <VersionToast />
        </VersionToastViewport>
      )}
    </VersionToastProvider>
  );
}
